









import {Component, Prop, Vue} from 'vue-property-decorator';
import {namespace, State} from 'vuex-class';
import {MAFUser} from '@/store/User/types';
import BButton from 'buefy/src/components/button/Button.vue';
import BField from 'buefy/src/components/field/Field.vue';
import BInput from 'buefy/src/components/input/Input.vue';
import luxon from '@/plugins/luxon';
import {DateTime} from 'luxon';
import * as _ from 'lodash';
import {slideOutChatContainer} from '@/components/Dashboard/types';


const friendPath = 'friendState';
const friendNamespace = namespace(friendPath);

const userPath = 'userState';
const userNamespace = namespace(userPath);

@Component({
    components: {BButton},
})
export default class SlideOutChatContainer extends slideOutChatContainer {

    public showList: boolean;
    @Prop() public hide!: boolean;

    constructor() {
        super();
        this.showList = true;
    }


    public showChat() {
        this.showList = false;
    }

    public showUsers() {
        this.showList = true;
    }

    public toggleView() {
        this.showList = !this.showList;
    }
}
